module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/211.aef2e63c.png";